<template>
  <motion.div
    class="historia-page"
    :initial="{ opacity: 0 }"
    :animate="{ opacity: 1 }"
    :transition="{ duration: 0.25 }"
  >
    <motion.div class="modern-header">
      <motion.div class="header-container">
        <motion.div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ currentWorkspace?.nome || workspaceNome }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceHistoria.breadcrumbCurrent') }}</span>
          </nav>
        </motion.div>

        <motion.div class="title-section">
          <motion.div class="title-content">
            <motion.div class="title-icon">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
              </svg>
            </motion.div>
            <motion.div class="title-text">
              <h1 class="main-title">{{ t('workspaceHistoria.title') }}</h1>
              <p class="subtitle">{{ t('workspaceHistoria.subtitle') }}</p>
            </motion.div>
          </motion.div>
          <motion.div class="workspace-badge" :class="`type-${(currentWorkspace?.tipo || 'TAREFAS').toLowerCase()}`">
            <motion.div class="badge-icon">
              <svg v-if="currentWorkspace?.tipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
              </svg>
            </motion.div>
            <span class="badge-text">{{ currentWorkspace?.tipo || 'TAREFAS' }}</span>
          </motion.div>
        </motion.div>

        <motion.div class="actions-section">
          <div class="actions-left">
            <button type="button" class="action-button secondary filtros-mob" @click="sidebarAberta = !sidebarAberta">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
              </svg>
              {{ t('workspaceHistoria.filters') }}
            </button>
            <button type="button" class="action-button secondary" @click="abrirDrawerArquivados">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
              </svg>
              {{ t('workspaceHistoria.archived') }}
              <span v-if="totalArquivados > 0" class="arq-badge">{{ totalArquivados }}</span>
            </button>
          </div>
          <div class="actions-right">
            <div class="panel-toggles" role="group" :aria-label="t('workspaceHistoria.panelTogglesAria')">
              <div class="panel-toggle">
                <span class="panel-toggle-label">💳 {{ t('workspaceHistoria.panelFinance') }}</span>
                <button
                  type="button"
                  class="toggle-switch"
                  :class="{ active: showPainelFinanceiro }"
                  :aria-pressed="showPainelFinanceiro"
                  :aria-label="t('workspaceHistoria.panelFinanceAria')"
                  @click="togglePainel('financeiro')"
                >
                  <span class="toggle-switch-slider" />
                </button>
              </div>
              <div class="panel-toggle">
                <span class="panel-toggle-label">⏱️ {{ t('workspaceHistoria.panelHours') }}</span>
                <button
                  type="button"
                  class="toggle-switch"
                  :class="{ active: showPainelHoras }"
                  :aria-pressed="showPainelHoras"
                  :aria-label="t('workspaceHistoria.panelHoursAria')"
                  @click="togglePainel('horas')"
                >
                  <span class="toggle-switch-slider" />
                </button>
              </div>
              <div class="panel-toggle">
                <span class="panel-toggle-label">🏷️ {{ t('workspaceHistoria.panelTags') }}</span>
                <button
                  type="button"
                  class="toggle-switch"
                  :class="{ active: showPainelTags }"
                  :aria-pressed="showPainelTags"
                  :aria-label="t('workspaceHistoria.panelTagsAria')"
                  @click="togglePainel('tags')"
                >
                  <span class="toggle-switch-slider" />
                </button>
              </div>
            </div>
            <button
              type="button"
              class="action-button secondary"
              :disabled="exportandoPdf || loading || !!erro"
              @click="exportarRelatorioPdf"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              {{ exportandoPdf ? t('workspaceHistoria.exportPdfGenerating') : t('workspaceHistoria.exportPdf') }}
            </button>
            <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
              </svg>
              {{ t('workspaceHistoria.back') }}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </motion.div>

    <div class="page-content">
    <div class="layout">
      <aside class="sidebar" :class="{ open: sidebarAberta }">
        <div class="sidebar-inner">
          <div class="sidebar-intro">
            <div class="sidebar-intro-head">
              <span class="sidebar-intro-icon-wrap" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
                </svg>
              </span>
              <div class="sidebar-intro-text">
                <strong>{{ t('workspaceHistoria.filtersTitle') }}</strong>
                <p>{{ t('workspaceHistoria.filtersHint') }}</p>
              </div>
            </div>
            <div class="sidebar-intro-actions">
              <button
                type="button"
                class="btn-apply-filter"
                :disabled="loading"
                @click="aplicarFiltros"
              >
                <svg class="btn-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                {{ loading ? t('workspaceHistoria.applying') : t('workspaceHistoria.applyFilters') }}
              </button>
              <button type="button" class="btn-clear-filter" @click="limparFiltros">
                <svg class="btn-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
                {{ t('workspaceHistoria.clear') }}
              </button>
            </div>
          </div>

          <div class="sidebar-filtros-scroll">
          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.usuarios }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.usuarios"
              @click="toggleFiltroSec('usuarios')"
            >
              <span class="sec-ico">👤</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.assignedUsers') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.usuarios" class="filtro-sec-body">
            <motion.div class="chip-list">
              <label
                v-for="u in workspaceUsers"
                :key="'a-' + u.id"
                class="filter-chip"
                :class="{ active: filtros.usuarioAtribuidoIds.includes(u.id) }"
              >
                <input v-model="filtros.usuarioAtribuidoIds" type="checkbox" :value="u.id" class="sr-only" />
                <span class="chip-avatar">
                  <img
                    v-if="resolveAvatarUrl(u.fotoPerfil)"
                    :src="resolveAvatarUrl(u.fotoPerfil)"
                    :alt="u.nomeCompleto"
                    class="chip-avatar-img"
                  />
                  <span v-else class="chip-avatar-fallback">{{ userInitials(u.nomeCompleto) }}</span>
                </span>
                <span class="chip-label">{{ u.nomeCompleto }}</span>
              </label>
            </motion.div>
            </div>
          </section>

          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.atividades }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.atividades"
              @click="toggleFiltroSec('atividades')"
            >
              <span class="sec-ico">⏱️</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.activitiesHours') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.atividades" class="filtro-sec-body">
            <motion.div class="chip-list">
              <label
                v-for="u in workspaceUsers"
                :key="'v-' + u.id"
                class="filter-chip"
                :class="{ active: filtros.usuarioAtividadeIds.includes(u.id) }"
              >
                <input v-model="filtros.usuarioAtividadeIds" type="checkbox" :value="u.id" class="sr-only" />
                <span class="chip-avatar">
                  <img
                    v-if="resolveAvatarUrl(u.fotoPerfil)"
                    :src="resolveAvatarUrl(u.fotoPerfil)"
                    :alt="u.nomeCompleto"
                    class="chip-avatar-img"
                  />
                  <span v-else class="chip-avatar-fallback">{{ userInitials(u.nomeCompleto) }}</span>
                </span>
                <span class="chip-label">{{ u.nomeCompleto }}</span>
              </label>
            </motion.div>
            </div>
          </section>

          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.periodo }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.periodo"
              @click="toggleFiltroSec('periodo')"
            >
              <span class="sec-ico">📅</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.period') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.periodo" class="filtro-sec-body">
            <motion.div class="datepicker-field">
              <span class="field-lbl">{{ t('workspaceHistoria.from') }}</span>
              <VueDatePicker
                v-model="periodoInicioDate"
                v-bind="dpOpts"
:placeholder="t('workspaceHistoria.dateStart')"
                class="custom-datepicker custom-datepicker--relatorio w-full"
              />
            </motion.div>
            <motion.div class="datepicker-field">
              <span class="field-lbl">{{ t('workspaceHistoria.to') }}</span>
              <VueDatePicker
                v-model="periodoFimDate"
                v-bind="dpOpts"
:placeholder="t('workspaceHistoria.dateEnd')"
                class="custom-datepicker custom-datepicker--relatorio w-full"
              />
            </motion.div>
            </div>
          </section>

          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.financeiros }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.financeiros"
              @click="toggleFiltroSec('financeiros')"
            >
              <span class="sec-ico">💰</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.financials') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.financeiros" class="filtro-sec-body">
            <div class="pill-row pill-row--finance">
              <label
                v-for="opt in financeiroStatusOpcoes"
                :key="opt.value"
                class="filter-pill filter-pill--finance"
                :class="[
                  'filter-pill--' + opt.key,
                  { active: filtros.financeiroStatus.includes(opt.value) }
                ]"
              >
                <input
                  v-model="filtros.financeiroStatus"
                  type="checkbox"
                  :value="opt.value"
                  class="sr-only"
                />
                <span class="filter-pill-icon-wrap" :style="{ backgroundColor: opt.corSoft, color: opt.cor }">
                  <span class="filter-pill-icon">{{ opt.icon }}</span>
                </span>
                <span class="filter-pill-text">{{ financeiroStatusLabel(opt) }}</span>
              </label>
            </div>
            <p class="sec-hint">{{ t('workspaceHistoria.financialPeriodHint') }}</p>
            <motion.div class="datepicker-field">
              <span class="field-lbl">{{ t('workspaceHistoria.from') }}</span>
              <VueDatePicker
                v-model="periodoFinInicioDate"
                v-bind="dpOpts"
:placeholder="t('workspaceHistoria.optional')"
                class="custom-datepicker custom-datepicker--relatorio w-full"
              />
            </motion.div>
            <motion.div class="datepicker-field">
              <span class="field-lbl">{{ t('workspaceHistoria.to') }}</span>
              <VueDatePicker
                v-model="periodoFinFimDate"
                v-bind="dpOpts"
:placeholder="t('workspaceHistoria.optional')"
                class="custom-datepicker custom-datepicker--relatorio w-full"
              />
            </motion.div>
            </div>
          </section>

          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.progresso }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.progresso"
              @click="toggleFiltroSec('progresso')"
            >
              <span class="sec-ico">📊</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.taskProgress') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.progresso" class="filtro-sec-body">
            <motion.div class="pill-row">
              <label v-for="opt in progressoOpcoes" :key="opt.value" class="filter-pill" :class="{ active: filtros.progressoStatus.includes(opt.value) }">
                <input v-model="filtros.progressoStatus" type="checkbox" :value="opt.value" class="sr-only" />
                {{ progressoLabel(opt) }}
              </label>
            </motion.div>
            </div>
          </section>

          <section class="filtro-sec" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.tags }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.tags"
              @click="toggleFiltroSec('tags')"
            >
              <span class="sec-ico">🏷️</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.tags') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.tags" class="filtro-sec-body">
            <motion.div v-for="cat in categoriasTags" :key="cat.id" class="tag-cat-block">
              <p class="tag-cat-title">{{ cat.nome }}</p>
              <motion.div class="tags-list">
                <button
                  v-for="tag in cat.tags || []"
                  :key="tag.id"
                  type="button"
                  class="tag-filter-item"
                  :class="{ selected: filtros.tagIds.includes(tag.id) }"
                  :style="{ backgroundColor: tag.cor || '#6366f1' }"
                  @click="toggleTag(tag.id)"
                >
                  <span class="tag-icon" :style="{ backgroundColor: tag.cor || '#6366f1' }">
                    {{ getTagEmoji(tag.icone) }}
                  </span>
                  <span class="tag-name" :style="{ color: getTextColor(tag.cor) }">{{ tag.nome }}</span>
                </button>
              </motion.div>
            </motion.div>
            <p v-if="!categoriasTags.length" class="muted small">{{ t('workspaceHistoria.noTagsConfigured') }}</p>
            </div>
          </section>

          <section class="filtro-sec filtro-mov" :class="{ 'filtro-sec--collapsed': !filtroSecAberta.inatividade }">
            <button
              type="button"
              class="sec-title sec-title-toggle"
              :aria-expanded="filtroSecAberta.inatividade"
              @click="toggleFiltroSec('inatividade')"
            >
              <span class="sec-ico">⏸️</span>
              <span class="sec-title-label">{{ t('workspaceHistoria.inactivity') }}</span>
              <svg class="sec-chevron" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
            <div v-show="filtroSecAberta.inatividade" class="filtro-sec-body">
            <p class="sec-hint">{{ t('workspaceHistoria.inactivityHint') }}</p>
            <div class="mov-panel" :class="{ 'mov-panel--active': usarSemMovimentacao }">
              <label class="mov-panel-toggle">
                <input v-model="usarSemMovimentacao" type="checkbox" class="sr-only" />
                <span class="mov-panel-icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </span>
                <span class="mov-panel-copy">
                  <span class="mov-panel-title">{{ t('workspaceHistoria.noMovement') }}</span>
                  <span class="mov-panel-desc">{{ t('workspaceHistoria.noMovementDesc') }}</span>
                </span>
                <span class="mov-panel-switch" aria-hidden="true"></span>
              </label>
              <motion.div
                class="mov-stepper"
                :class="{ 'mov-stepper--disabled': !usarSemMovimentacao }"
              >
                <span class="mov-stepper-label">{{ t('workspaceHistoria.atLeast') }}</span>
                <div class="mov-stepper-control">
                  <button
                    type="button"
                    class="mov-step-btn"
                    :disabled="!usarSemMovimentacao || filtros.semMovimentacaoDias <= 1"
:aria-label="t('workspaceHistoria.decreaseDays')"
                    @click="ajustarSemMovimentacaoDias(-1)"
                  >
                    −
                  </button>
                  <input
                    v-model.number="filtros.semMovimentacaoDias"
                    type="number"
                    min="1"
                    max="365"
                    class="mov-step-input"
                    :disabled="!usarSemMovimentacao"
                    @blur="normalizarSemMovimentacaoDias"
                  />
                  <button
                    type="button"
                    class="mov-step-btn"
                    :disabled="!usarSemMovimentacao"
:aria-label="t('workspaceHistoria.increaseDays')"
                    @click="ajustarSemMovimentacaoDias(1)"
                  >
                    +
                  </button>
                </div>
                <span class="mov-stepper-unit">{{ t('workspaceHistoria.days') }}</span>
              </motion.div>
            </div>
            </div>
          </section>

          </div>
        </div>
      </aside>

      <main ref="relatorioMainRef" class="main">
        <motion.div
          v-if="loading"
          class="card muted"
          :initial="{ opacity: 0 }"
          :animate="{ opacity: 1 }"
        >
          {{ t('workspaceHistoria.loading') }}
        </motion.div>
        <motion.div
          v-else-if="erro"
          class="card erro"
          :initial="{ opacity: 0, scale: 0.98 }"
          :animate="{ opacity: 1, scale: 1 }"
        >
          {{ erro }}
        </motion.div>
        <template v-else>
          <motion.section class="kpis" :initial="{ opacity: 0, y: 12 }" :animate="{ opacity: 1, y: 0 }">
            <motion.div class="kpi card kpi-tasks">
              <span class="kpi-icon">📋</span>
              <div>
                <span class="kpi-lbl">{{ t('workspaceHistoria.kpiTasks') }}</span>
                <span class="kpi-val">{{ relatorio.resumo?.totalFiltrado ?? 0 }}</span>
              </div>
            </motion.div>
            <motion.div class="kpi card kpi-horas">
              <span class="kpi-icon">⏱️</span>
              <div>
                <span class="kpi-lbl">{{ t('workspaceHistoria.kpiHours') }}</span>
                <span class="kpi-val">{{ totalHorasFormatado }}</span>
              </div>
            </motion.div>
            <motion.div class="kpi card kpi-check">
              <span class="kpi-icon">✅</span>
              <div>
                <span class="kpi-lbl">{{ t('workspaceHistoria.kpiChecklist') }}</span>
                <span class="kpi-val">{{ checklistPct }}%</span>
              </div>
            </motion.div>
          </motion.section>

          <motion.section
            v-if="showPainelFinanceiro"
            class="panel-card panel-card--full panel-card--finance"
            :initial="{ opacity: 0, y: 12 }"
            :animate="{ opacity: 1, y: 0 }"
            :transition="{ delay: 0.05 }"
          >
            <div class="panel-head">
              <div class="panel-head-left">
                <span class="panel-head-icon">💳</span>
                <div>
                  <h2>{{ t('workspaceHistoria.financeSummary') }}</h2>
                  <p class="panel-subtitle">{{ t('workspaceHistoria.financeSubtitle') }}</p>
                </div>
              </div>
              <span class="panel-badge panel-badge--neutral">{{ finResumo.qtdTotal }} {{ finResumo.qtdTotal === 1 ? t('workspaceHistoria.receivable') : t('workspaceHistoria.receivables') }}</span>
            </div>
            <div v-if="!finResumo.qtdTotal" class="empty-hint">{{ t('workspaceHistoria.noReceivables') }}</div>
            <div v-else class="fin-dashboard">
              <article
                v-for="card in finCards"
                :key="card.key"
                class="fin-stat-card"
                :class="'fin-stat-card--' + card.key"
              >
                <div class="fin-stat-top">
                  <span class="fin-stat-icon" :style="{ backgroundColor: card.corSoft }">{{ card.icon }}</span>
                  <span class="fin-stat-qtd">{{ card.qtd }} {{ card.qtd === 1 ? t('workspaceHistoria.item') : t('workspaceHistoria.items') }}</span>
                </div>
                <span class="fin-stat-label">{{ card.label }}</span>
                <MoneyAmount :value="card.valor" tag="strong" class="fin-stat-value" />
                <div class="fin-stat-bar-wrap">
                  <div
                    class="fin-stat-bar"
                    :style="{ width: card.pct + '%', backgroundColor: card.cor }"
                  />
                </div>
                <span class="fin-stat-pct">{{ t('workspaceHistoria.pctOfTotal', { pct: card.pct }) }}</span>
              </article>
            </div>
            <div v-if="finResumo.qtdTotal" class="fin-total-row">
              <span>{{ t('workspaceHistoria.grandTotal') }}</span>
              <MoneyAmount :value="finResumo.valorTotal" tag="strong" />
            </div>
          </motion.section>

          <motion.section
            v-if="showPainelHoras"
            class="panel-card panel-card--full panel-card--horas"
            :initial="{ opacity: 0, y: 12 }"
            :animate="{ opacity: 1, y: 0 }"
            :transition="{ delay: 0.08 }"
          >
            <div class="panel-head">
              <div class="panel-head-left">
                <span class="panel-head-icon">⏱️</span>
                <div>
                  <h2>{{ t('workspaceHistoria.hoursByUser') }}</h2>
                  <p class="panel-subtitle">{{ t('workspaceHistoria.hoursSubtitle') }}</p>
                </div>
              </div>
              <span class="panel-badge">{{ t('workspaceHistoria.usersCount', { hours: totalHorasFormatado, count: relatorio.horasPorUsuario?.length || 0 }) }}</span>
            </div>
            <div v-if="!(relatorio.horasPorUsuario && relatorio.horasPorUsuario.length)" class="empty-hint">
              {{ t('workspaceHistoria.noActivities') }}
            </div>
            <ul v-else class="horas-dashboard">
              <li
                v-for="(h, idx) in relatorio.horasPorUsuario"
                :key="h.usuarioId"
                class="hora-card"
              >
                <span class="hora-rank">{{ idx + 1 }}</span>
                <span class="hora-avatar">
                  <img
                    v-if="resolveAvatarUrl(getHorasUserFoto(h))"
                    :src="resolveAvatarUrl(getHorasUserFoto(h))"
                    :alt="h.nome"
                    class="hora-avatar-img"
                  />
                  <span v-else class="hora-avatar-fallback">{{ userInitials(h.nome) }}</span>
                </span>
                <div class="hora-bar-col">
                  <div class="hora-bar-top">
                    <span class="hora-nome">{{ h.nome }}</span>
                    <strong class="hora-tempo">{{ h.totalFormatado }}</strong>
                  </div>
                  <div class="hora-bar-wrap">
                    <div class="hora-bar" :style="{ width: barWidth(h.totalMinutos) }" />
                  </div>
                </div>
              </li>
            </ul>
          </motion.section>

          <motion.section v-if="showPainelTags" class="panel-card">
            <motion.div class="panel-head"><h2>{{ t('workspaceHistoria.totalsByTag') }}</h2></motion.div>
            <motion.div class="tags-list tags-list--main">
              <span
                v-for="t in relatorio.totaisPorTag || []"
                :key="t.tagId"
                class="tag-item tag-item--readonly"
                :style="{ backgroundColor: t.cor || '#6366f1' }"
              >
                <span class="tag-icon" :style="{ backgroundColor: t.cor || '#6366f1' }">{{ getTagEmoji(findTagMeta(t.tagId)?.icone) }}</span>
                <span class="tag-name" :style="{ color: getTextColor(t.cor) }">{{ t.nome }}</span>
                <span class="tag-count" :style="{ color: getTextColor(t.cor) }">{{ t.quantidadeTasks }}</span>
              </span>
              <span v-if="!(relatorio.totaisPorTag && relatorio.totaisPorTag.length)" class="empty-hint">—</span>
            </motion.div>
          </motion.section>

          <motion.section class="panel-card panel-card--tasks">
            <motion.div class="panel-head">
              <h2>{{ t('workspaceHistoria.tasksFound') }}</h2>
              <span class="panel-badge">{{ relatorio.tasks?.length || 0 }} {{ t('workspaceHistoria.onThisPage') }}</span>
            </motion.div>
            <motion.div v-if="!(relatorio.tasks && relatorio.tasks.length)" class="empty-hint">{{ t('workspaceHistoria.noTasksMatch') }}</motion.div>
            <motion.div v-else class="tasks-grid">
              <RelatorioTaskCard
                v-for="task in relatorio.tasks"
                :key="task.id"
                :task="task"
                :workspace-users="workspaceUsers"
                :show-financeiro="showPainelFinanceiro"
                :show-horas="showPainelHoras"
                @click="abrirTask(task)"
              />
            </motion.div>
            <motion.div v-if="totalPages > 1" class="paginacao">
              <button type="button" class="btn-ghost" :disabled="page <= 0" @click="irPagina(page - 1)">{{ t('workspaceHistoria.prev') }}</button>
              <span class="muted">{{ t('workspaceHistoria.pageOf', { current: page + 1, total: totalPages }) }}</span>
              <button type="button" class="btn-ghost" :disabled="page >= totalPages - 1" @click="irPagina(page + 1)">{{ t('workspaceHistoria.next') }}</button>
            </motion.div>
          </motion.section>
        </template>
      </main>
    </div>
    </div>

    <ArchivedItemsDrawer
      :open="drawerArquivados"
      :title="t('workspaceHistoria.archivedTitle')"
      :hint="t('workspaceHistoria.archivedHint')"
      :loading="loadingArquivados"
      :items="arquivados"
      :total="totalArquivados"
      :page="arquivadosPage"
      :page-size="ARCHIVED_PAGE_SIZE"
      :total-pages="arquivadosTotalPages"
      :fields="archivedTaskFields"
      :empty-text="t('workspaceHistoria.archivedEmpty')"
      :busy-id="busyId"
      @close="drawerArquivados = false"
      @desarquivar="desarquivar"
      @page-change="carregarArquivados"
    />



    <TaskDetailModal
      :is-open="showTask"
      :task="selectedTask"
      @close="showTask = false"
      @taskUpdated="onTaskAtualizada"
    />
  </motion.div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { motion } from 'motion-v'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { useWorkspaceStore } from '../stores/workspace'
import api from '../services/api'
import TaskDetailModal from '../components/TaskDetailModal.vue'
import ArchivedItemsDrawer from '../components/ArchivedItemsDrawer.vue'
import MoneyAmount from '../components/MoneyAmount.vue'
import RelatorioTaskCard from '../components/RelatorioTaskCard.vue'
import { getTagIcon } from '../utils/iconMapper'
import { datePickerLocaleFor } from '../utils/datePickerLocale'
import { intlLocaleFor } from '../utils/format'

const { t, locale } = useI18n()
const route = useRoute()
const workspaceStore = useWorkspaceStore()

const workspaceId = computed(() => Number(route.params.id))
const workspaceNome = computed(() => workspaceStore.currentWorkspace?.nome || t('workspaceDashboard.defaultName'))
const currentWorkspace = computed(() => workspaceStore.currentWorkspace)

const loading = ref(false)
const erro = ref('')
const relatorio = ref({})
const page = ref(0)
const size = 50
const sidebarAberta = ref(false)

const filtroSecAberta = reactive({
  usuarios: true,
  atividades: true,
  periodo: true,
  financeiros: true,
  progresso: true,
  tags: true,
  inatividade: true
})

const toggleFiltroSec = (key) => {
  filtroSecAberta[key] = !filtroSecAberta[key]
}

const workspaceUsers = ref([])
const categoriasTags = ref([])

const archivedTaskFields = computed(() => [
  { key: 'titulo', label: t('workspaceHistoria.fieldTitle'), primary: true },
  { key: 'colunaNome', label: t('workspaceHistoria.fieldColumn') }
])

const ARCHIVED_PAGE_SIZE = 30

const drawerArquivados = ref(false)
const loadingArquivados = ref(false)
const arquivados = ref([])
const arquivadosPage = ref(0)
const arquivadosTotalPages = ref(0)
const busyId = ref(null)
const totalArquivados = ref(0)

const showTask = ref(false)
const selectedTask = ref(null)

const usarSemMovimentacao = ref(false)

const showPainelFinanceiro = ref(true)
const showPainelHoras = ref(true)
const showPainelTags = ref(true)

const relatorioMainRef = ref(null)
const exportandoPdf = ref(false)

const paineisStorageKey = () => `historia-panels:${workspaceId.value}`

function loadPaineisPrefs() {
  try {
    const saved = localStorage.getItem(paineisStorageKey())
    if (saved) return JSON.parse(saved)
  } catch (_) { /* ignore */ }
  return { financeiro: true, horas: true, tags: true }
}

function savePaineisPrefs() {
  try {
    localStorage.setItem(
      paineisStorageKey(),
      JSON.stringify({
        financeiro: showPainelFinanceiro.value,
        horas: showPainelHoras.value,
        tags: showPainelTags.value
      })
    )
  } catch (_) { /* ignore */ }
}

function applyPaineisPrefs() {
  const p = loadPaineisPrefs()
  showPainelFinanceiro.value = p.financeiro !== false
  showPainelHoras.value = p.horas !== false
  showPainelTags.value = p.tags !== false
}

function togglePainel(key) {
  if (key === 'financeiro') showPainelFinanceiro.value = !showPainelFinanceiro.value
  else if (key === 'horas') showPainelHoras.value = !showPainelHoras.value
  else if (key === 'tags') showPainelTags.value = !showPainelTags.value
  savePaineisPrefs()
}

function primeiroDiaMes() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
}

function ultimoDiaMes() {
  const d = new Date()
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0)
  return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}`
}

const filtros = reactive({
  periodoInicio: primeiroDiaMes(),
  periodoFim: ultimoDiaMes(),
  periodoFinanceiroInicio: '',
  periodoFinanceiroFim: '',
  usuarioAtribuidoIds: [],
  usuarioAtividadeIds: [],
  tagIds: [],
  financeiroStatus: [],
  progressoStatus: [],
  semMovimentacaoDias: 7
})

const maxMinutosHoras = computed(() => {
  const list = relatorio.value.horasPorUsuario || []
  if (!list.length) return 1
  return Math.max(...list.map((h) => h.totalMinutos || 0), 1)
})

const totalHorasFormatado = computed(() => {
  const list = relatorio.value.horasPorUsuario || []
  const min = list.reduce((s, h) => s + (h.totalMinutos || 0), 0)
  const h = Math.floor(min / 60)
  const m = min % 60
  if (h > 0 && m > 0) return `${h}h ${m}m`
  if (h > 0) return `${h}h`
  return `${m}m`
})

const checklistPct = computed(() => {
  const r = relatorio.value.resumo || {}
  const t = r.totalChecklistItens || 0
  if (!t) return 0
  return Math.round(((r.totalChecklistConcluidos || 0) / t) * 100)
})

const finResumo = computed(() => {
  const f = relatorio.value.resumoFinanceiro || {}
  const valorPendente = Number(f.valorPendente) || 0
  const valorVencido = Number(f.valorVencido) || 0
  const valorPago = Number(f.valorPago) || 0
  const valorTotal = valorPendente + valorVencido + valorPago
  return {
    qtdPendente: f.qtdPendente || 0,
    qtdVencido: f.qtdVencido || 0,
    qtdPago: f.qtdPago || 0,
    qtdTotal: f.qtdTotal || 0,
    valorPendente,
    valorVencido,
    valorPago,
    valorTotal
  }
})

const finCards = computed(() => {
  const r = finResumo.value
  const valorTotal = r.valorTotal || 0
  const pct = (v) => (valorTotal > 0 ? Math.round((v / valorTotal) * 100) : 0)
  return [
    {
      key: 'pendente',
      label: t('workspaceHistoria.taskCard.pending'),
      icon: '⏳',
      qtd: r.qtdPendente,
      valor: r.valorPendente,
      cor: '#6366f1',
      corSoft: 'rgba(99, 102, 241, 0.15)',
      pct: pct(r.valorPendente)
    },
    {
      key: 'vencido',
      label: t('workspaceHistoria.taskCard.overdue'),
      icon: '⚠️',
      qtd: r.qtdVencido,
      valor: r.valorVencido,
      cor: '#ef4444',
      corSoft: 'rgba(239, 68, 68, 0.15)',
      pct: pct(r.valorVencido)
    },
    {
      key: 'pago',
      label: t('workspaceHistoria.taskCard.paid'),
      icon: '✓',
      qtd: r.qtdPago,
      valor: r.valorPago,
      cor: '#10b981',
      corSoft: 'rgba(16, 185, 129, 0.15)',
      pct: pct(r.valorPago)
    }
  ]
})

const totalPages = computed(() => relatorio.value.totalPages || 0)

const barWidth = (minutos) => {
  const pct = Math.round(((minutos || 0) / maxMinutosHoras.value) * 100)
  return `${Math.max(pct, 4)}%`
}

function financeiroStatusLabel (opt) {
  return opt.labelKey ? t(`workspaceHistoria.${opt.labelKey}`) : opt.label
}
function progressoLabel (opt) {
  return opt.labelKey ? t(`workspaceHistoria.${opt.labelKey}`) : opt.label
}

const financeiroStatusOpcoes = [
  { value: 'EM_ABERTO', key: 'aberto', labelKey: 'financeOnTime', icon: '⏳', cor: '#6366f1', corSoft: 'rgba(99, 102, 241, 0.18)' },
  { value: 'VENCIDO', key: 'vencido', labelKey: 'financeOverdue', icon: '⚠️', cor: '#ef4444', corSoft: 'rgba(239, 68, 68, 0.18)' },
  { value: 'PAGO', key: 'pago', labelKey: 'financePaid', icon: '✓', cor: '#10b981', corSoft: 'rgba(16, 185, 129, 0.18)' }
]

const progressoOpcoes = [
  { value: 'NO_PRAZO', labelKey: 'progressOnTime' },
  { value: 'ATRASADO', labelKey: 'progressOverdue' },
  { value: 'HOJE', labelKey: 'progressToday' },
  { value: 'PROXIMOS_7_DIAS', labelKey: 'progressNext7' },
  { value: 'MES_ATUAL', labelKey: 'progressThisMonth' }
]

const dpOpts = computed(() => ({
  enableTimePicker: false,
  format: 'dd/MM/yyyy',
  previewFormat: 'dd/MM/yyyy',
  locale: datePickerLocaleFor(locale.value),
  autoApply: true,
  teleport: true
}))

function parseYmd (str) {
  if (!str) return null
  const parts = String(str).split('T')[0].split('-').map(Number)
  if (parts.length < 3 || !parts[0]) return null
  return new Date(parts[0], parts[1] - 1, parts[2])
}

function toYmd (date) {
  if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) return ''
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const periodoInicioDate = computed({
  get: () => parseYmd(filtros.periodoInicio),
  set: (v) => { filtros.periodoInicio = toYmd(v) }
})
const periodoFimDate = computed({
  get: () => parseYmd(filtros.periodoFim),
  set: (v) => { filtros.periodoFim = toYmd(v) }
})
const periodoFinInicioDate = computed({
  get: () => parseYmd(filtros.periodoFinanceiroInicio),
  set: (v) => { filtros.periodoFinanceiroInicio = toYmd(v) }
})
const periodoFinFimDate = computed({
  get: () => parseYmd(filtros.periodoFinanceiroFim),
  set: (v) => { filtros.periodoFinanceiroFim = toYmd(v) }
})

const isLightColor = (hex) => {
  if (!hex || typeof hex !== 'string') return true
  const c = hex.replace('#', '')
  if (c.length < 6) return true
  const r = parseInt(c.slice(0, 2), 16)
  const g = parseInt(c.slice(2, 4), 16)
  const b = parseInt(c.slice(4, 6), 16)
  return ((r * 299) + (g * 587) + (b * 114)) / 1000 > 128
}

const getTextColor = (backgroundColor) => (isLightColor(backgroundColor) ? '#000000' : '#FFFFFF')
const getTagEmoji = (iconValue) => getTagIcon(iconValue)

const userInitials = (nome) => {
  if (!nome) return '?'
  const parts = String(nome).trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

const resolveAvatarUrl = (url) => {
  if (!url) return null
  const clean = String(url).trim()
  if (!clean) return null
  if (/^https?:\/\//i.test(clean) || clean.startsWith('data:')) return clean
  if (clean.startsWith('/')) {
    const base = (api.defaults.baseURL || '').replace(/\/+$/, '')
    return `${base}${clean}`
  }
  return clean
}

const getHorasUserFoto = (h) => {
  if (h?.fotoPerfil) return h.fotoPerfil
  const u = workspaceUsers.value.find((x) => Number(x.id) === Number(h?.usuarioId))
  return u?.fotoPerfil ?? null
}

const toggleTag = (tagId) => {
  const idx = filtros.tagIds.indexOf(tagId)
  if (idx >= 0) filtros.tagIds.splice(idx, 1)
  else filtros.tagIds.push(tagId)
}

const splitTagsResumo = (resumo) => {
  if (!resumo) return []
  return String(resumo).split(',').map((s) => s.trim()).filter(Boolean)
}

const findTagMeta = (tagId) => {
  for (const cat of categoriasTags.value || []) {
    const tag = (cat.tags || []).find((t) => t.id === tagId)
    if (tag) return tag
  }
  return null
}

const findTagByName = (nome) => {
  const n = String(nome || '').trim().toLowerCase()
  if (!n) return null
  for (const cat of categoriasTags.value || []) {
    const tag = (cat.tags || []).find((t) => String(t.nome || '').trim().toLowerCase() === n)
    if (tag) return tag
  }
  return null
}

const formatDate = (value) => {
  if (value == null || value === '') return '—'
  if (Array.isArray(value)) {
    const [y, m, day] = value
    if (y != null && m != null && day != null) {
      return `${String(day).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`
    }
  }
  const str = String(value)
  const datePart = str.split('T')[0]
  const [y, m, d] = datePart.split('-')
  if (y && m && d) return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`
  const parsed = new Date(str)
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString(intlLocaleFor(locale.value))
  }
  return str
}

const montarPayload = () => {
  const body = {
    periodoInicio: filtros.periodoInicio || null,
    periodoFim: filtros.periodoFim || null,
    periodoFinanceiroInicio: filtros.periodoFinanceiroInicio || null,
    periodoFinanceiroFim: filtros.periodoFinanceiroFim || null,
    usuarioAtribuidoIds: [...filtros.usuarioAtribuidoIds],
    usuarioAtividadeIds: [...filtros.usuarioAtividadeIds],
    tagIds: [...filtros.tagIds],
    financeiroStatus: [...filtros.financeiroStatus],
    progressoStatus: [...filtros.progressoStatus],
    page: page.value,
    size
  }
  if (usarSemMovimentacao.value && filtros.semMovimentacaoDias > 0) {
    body.semMovimentacaoDias = filtros.semMovimentacaoDias
  }
  return body
}

const carregarUsuariosETags = async () => {
  try {
    const [usersRes, cfgRes] = await Promise.all([
      api.get(`/workspace-acesso/workspace/${workspaceId.value}`),
      api.get(`/workspace-config/${workspaceId.value}/configuracoes`)
    ])
    const usersRaw = Array.isArray(usersRes.data) ? usersRes.data : []
    workspaceUsers.value = usersRaw.map((u) => ({
      id: u.usuarioId ?? u.id,
      nomeCompleto: u.usuarioNome ?? u.nomeCompleto ?? u.nome,
      fotoPerfil: u.usuarioFotoPerfil ?? u.fotoPerfil ?? null
    }))
    categoriasTags.value = cfgRes.data?.categorias || []
  } catch {
    workspaceUsers.value = []
    categoriasTags.value = []
  }
}

const carregarRelatorio = async () => {
  loading.value = true
  erro.value = ''
  sidebarAberta.value = false
  try {
    const res = await api.post(`/tasks/workspace/${workspaceId.value}/relatorio-analitico`, montarPayload())
    relatorio.value = res.data || {}
    totalArquivados.value = relatorio.value.totalArquivados ?? 0
  } catch (e) {
    erro.value = e.response?.data?.error || e.message || t('workspaceHistoria.errors.load')
    relatorio.value = {}
  } finally {
    loading.value = false
  }
}

const exportarRelatorioPdf = async () => {
  const target = relatorioMainRef.value
  if (!target || loading.value || erro.value) return

  exportandoPdf.value = true
  try {
    await nextTick()
    const previousMaxHeight = target.style.maxHeight
    const previousOverflow = target.style.overflow
    target.style.maxHeight = 'none'
    target.style.overflow = 'visible'

    const canvas = await html2canvas(target, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      windowWidth: target.scrollWidth,
      windowHeight: target.scrollHeight,
      logging: false
    })

    target.style.maxHeight = previousMaxHeight
    target.style.overflow = previousOverflow

    const imgData = canvas.toDataURL('image/png')
    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const imgWidth = pageWidth
    const imgHeight = (canvas.height * imgWidth) / canvas.width
    let heightLeft = imgHeight
    let position = 0

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    heightLeft -= pageHeight

    while (heightLeft > 0) {
      position = heightLeft - imgHeight
      pdf.addPage()
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
      heightLeft -= pageHeight
    }

    const wsSlug = String(workspaceNome.value || 'workspace').replace(/[^\w\-]+/g, '_')
    const dt = new Date().toISOString().slice(0, 10)
    pdf.save(`relatorio-${wsSlug}-${dt}.pdf`)
  } catch (e) {
    console.error('Erro ao exportar PDF do relatório:', e)
    window.alert(t('workspaceHistoria.errors.pdfExport'))
  } finally {
    exportandoPdf.value = false
  }
}

function ajustarSemMovimentacaoDias(delta) {
  const atual = Number(filtros.semMovimentacaoDias) || 7
  filtros.semMovimentacaoDias = Math.min(365, Math.max(1, atual + delta))
}

function normalizarSemMovimentacaoDias() {
  const n = Number(filtros.semMovimentacaoDias)
  if (!Number.isFinite(n) || n < 1) filtros.semMovimentacaoDias = 7
  else if (n > 365) filtros.semMovimentacaoDias = 365
  else filtros.semMovimentacaoDias = Math.round(n)
}

const aplicarFiltros = () => {
  page.value = 0
  carregarRelatorio()
}

const limparFiltros = () => {
  filtros.periodoInicio = primeiroDiaMes()
  filtros.periodoFim = ultimoDiaMes()
  filtros.periodoFinanceiroInicio = ''
  filtros.periodoFinanceiroFim = ''
  filtros.financeiroStatus = []
  filtros.progressoStatus = []
  filtros.tagIds = []
  filtros.semMovimentacaoDias = 7
  usarSemMovimentacao.value = false
  filtros.usuarioAtribuidoIds = []
  filtros.usuarioAtividadeIds = []
  page.value = 0
  carregarRelatorio()
}

const irPagina = (p) => {
  page.value = p
  carregarRelatorio()
}

const carregarArquivados = async (p = 0) => {
  loadingArquivados.value = true
  arquivadosPage.value = p
  try {
    const res = await api.get(`/tasks/workspace/${workspaceId.value}/arquivados`, {
      params: { page: p, size: ARCHIVED_PAGE_SIZE }
    })
    arquivados.value = res.data?.arquivados || []
    totalArquivados.value = res.data?.totalArquivados ?? 0
    arquivadosTotalPages.value = Number(res.data?.totalPages) || 0
    if (arquivadosTotalPages.value > 0 && p >= arquivadosTotalPages.value) {
      await carregarArquivados(arquivadosTotalPages.value - 1)
    }
  } catch {
    arquivados.value = []
    totalArquivados.value = 0
    arquivadosTotalPages.value = 0
  } finally {
    loadingArquivados.value = false
  }
}

const abrirDrawerArquivados = async () => {
  drawerArquivados.value = true
  await carregarArquivados(0)
}

const desarquivar = async (task) => {
  if (!task?.id) return
  busyId.value = task.id
  const paginaAtual = arquivadosPage.value
  try {
    await api.put(`/tasks/${task.id}/desarquivar`)
    const proxima =
      arquivados.value.length <= 1 && paginaAtual > 0 ? paginaAtual - 1 : paginaAtual
    await carregarArquivados(proxima)
    await carregarRelatorio()
  } catch (e) {
    erro.value = e.response?.data?.error || t('workspaceHistoria.errors.unarchive')
  } finally {
    busyId.value = null
  }
}

const abrirTask = async (row) => {
  if (!row?.id) return
  try {
    const r = await api.get(`/tasks/${row.id}`)
    selectedTask.value = r.data
    showTask.value = true
  } catch {
    erro.value = t('workspaceHistoria.errors.openTask')
  }
}

const onTaskAtualizada = () => {
  showTask.value = false
  carregarRelatorio()
}

onMounted(async () => {
  applyPaineisPrefs()
  await workspaceStore.loadWorkspace(workspaceId.value)
  await carregarUsuariosETags()
  await carregarRelatorio()
})

watch(workspaceId, async () => {
  applyPaineisPrefs()
  page.value = 0
  await workspaceStore.loadWorkspace(workspaceId.value)
  filtros.usuarioAtribuidoIds = []
  filtros.usuarioAtividadeIds = []
  await carregarUsuariosETags()
  await carregarRelatorio()
})
</script>

<style scoped>
.historia-page {
  width: 100%;
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.modern-header {
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
  margin-bottom: 0;
}

.header-container {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.breadcrumb-section {
  display: flex;
  align-items: center;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.breadcrumb-item:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.breadcrumb-separator {
  color: var(--text-muted);
  margin: 0 4px;
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 600;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.title-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);
  border-radius: 4px;
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.title-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.main-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.subtitle {
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
}

.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
}

.workspace-badge.type-crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.workspace-badge.type-tarefas {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
}

.badge-icon {
  display: flex;
  align-items: center;
}

.badge-text {
  font-weight: 600;
}

.actions-section {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.actions-left,
.actions-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.actions-right {
  margin-left: auto;
}

.panel-toggles {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
}

.panel-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 4px;
}

.panel-toggle-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.panel-toggle:has(.toggle-switch.active) .panel-toggle-label {
  color: var(--text-primary);
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
}

.toggle-switch.active {
  background: var(--accent-primary, #6366f1);
  border-color: var(--accent-primary, #6366f1);
}

.toggle-switch-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.toggle-switch.active .toggle-switch-slider {
  transform: translateX(20px);
}

.action-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-button.primary {
  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
}

.action-button.primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.action-button.secondary {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.action-button.secondary:hover {
  background: var(--bg-tertiary);
  transform: translateY(-1px);
}

.action-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.arq-badge {
  background: rgba(99, 102, 241, 0.2);
  color: var(--accent-primary);
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: 2px;
}

.page-content {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 24px;
  box-sizing: border-box;
}

.filtros-mob {
  display: none;
}

.layout {
  display: grid;
  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  width: 100%;
}

.main {
  min-width: 0;
}

.sidebar {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  position: sticky;
  top: 16px;
  align-self: start;
  max-height: calc(100vh - 32px);
  overflow: hidden;
}

.sidebar-inner {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  padding: 0;
}

.filtro-sec {
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--border-primary);
}

.filtro-sec h3 {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.chk-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 10px;
}

.chk-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chk {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  cursor: pointer;
}

.date-row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 8px;
  align-items: center;
  font-size: 13px;
}

.inp {
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 6px 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
}

.inp.num {
  width: 64px;
  margin-left: 8px;
}

.sec-hint {
  font-size: 12px;
  color: var(--text-secondary);
  margin: 8px 0 6px;
}

.tag-cat {
  margin-bottom: 10px;
}

.cat-nome {
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 6px;
  color: var(--text-secondary);
}

.tag-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.filtro-sec.compact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.btn-primary {
  padding: 10px 16px;
  border-radius: 4px;
  border: none;
  background: #6366f1;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-ghost {
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
}


.card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}

.kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.kpi {
  padding: 14px;
}

.kpi-lbl {
  display: block;
  font-size: 12px;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.kpi-val {
  font-size: 22px;
  font-weight: 700;
}

.kpi-val.fin {
  font-size: 14px;
}

h2 {
  margin: 0 0 12px;
  font-size: 17px;
}

.horas-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.hora-row {
  display: grid;
  grid-template-columns: 120px 1fr 72px;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
}

.hora-bar-wrap {
  height: 10px;
  background: var(--bg-primary);
  border-radius: 999px;
  overflow: hidden;
}

.hora-bar {
  height: 100%;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  border-radius: 999px;
  transform-origin: left center;
}

.hora-total {
  text-align: right;
  font-weight: 600;
}

.tag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid;
  font-size: 13px;
  background: var(--bg-primary);
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

th,
td {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid var(--border-primary);
}

.row-click {
  cursor: pointer;
}

.row-click:hover {
  background: rgba(99, 102, 241, 0.06);
}

.tags-cell {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.paginacao {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;
}

.muted {
  color: var(--text-secondary);
}

.small {
  font-size: 12px;
}

.erro {
  color: #b91c1c;
}

@media (max-width: 900px) {
  .title-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .actions-section {
    flex-direction: column;
    align-items: stretch;
  }

  .actions-right {
    margin-left: 0;
    justify-content: space-between;
  }

  .panel-toggles {
    flex: 1;
    justify-content: center;
  }

  .layout {
    grid-template-columns: 1fr;
  }

  .filtros-mob {
    display: flex;
  }

  .sidebar {
    display: none;
    position: fixed;
    z-index: 1500;
    left: 16px;
    right: 16px;
    top: 80px;
    max-height: calc(100vh - 96px);
    overflow: hidden;
  }

  .sidebar.open {
    display: block;
  }

  .sidebar.open .sidebar-inner {
    max-height: calc(100vh - 96px);
  }

  .hora-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

/* Sidebar profissional */
.sidebar-intro {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 12px 12px 8px;
  border-radius: 4px;
  background: linear-gradient(145deg, var(--bg-primary) 0%, rgba(99, 102, 241, 0.08) 100%);
  border: 1px solid rgba(99, 102, 241, 0.22);
  box-shadow: 0 4px 20px rgba(99, 102, 241, 0.08);
  overflow: hidden;
}
.sidebar-intro-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 14px 12px;
}
.sidebar-intro-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}
.sidebar-intro-icon-wrap svg {
  width: 20px;
  height: 20px;
}
.sidebar-intro-text strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
}
.sidebar-intro-text p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-secondary);
}
.sidebar-intro-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 10px 10px;
}
.btn-apply-filter,
.btn-clear-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  padding: 7px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.btn-apply-filter {
  border: none;
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
  color: #fff;
  box-shadow: 0 1px 6px rgba(99, 102, 241, 0.3);
}
.btn-apply-filter:hover:not(:disabled) {
  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);
}
.btn-apply-filter:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.btn-clear-filter {
  border: 1px solid var(--border-primary);
  background: transparent;
  color: var(--text-secondary);
}
.btn-clear-filter:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
  border-color: var(--border-hover);
}
.sidebar-intro-actions .btn-ico {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.sidebar-filtros-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding-bottom: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar {
  width: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-filtros-scroll::-webkit-scrollbar-thumb {
  background-color: var(--border-primary);
  border-radius: 8px;
}

.sidebar-filtros-scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--border-hover);
}

.sec-title,
.sec-title-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.sec-title-toggle {
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  transition: color 0.15s ease;
}

.sec-title-toggle:hover {
  color: var(--text-primary);
}

.sec-title-toggle:focus-visible {
  outline: 2px solid rgba(99, 102, 241, 0.45);
  outline-offset: 2px;
  border-radius: 4px;
}

.sec-title-label {
  flex: 1;
  min-width: 0;
}

.sec-chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-tertiary);
  transition: transform 0.2s ease;
}

.filtro-sec--collapsed .sec-title-toggle {
  margin-bottom: 0;
}

.filtro-sec--collapsed .sec-chevron {
  transform: rotate(-90deg);
}

.sec-ico { font-size: 14px; }
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.chip-list { display: flex; flex-direction: column; gap: 8px; }
.filter-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  cursor: pointer;
  transition: all 0.2s ease;
}
.filter-chip:hover { border-color: #6366f1; }
.filter-chip.active {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.12);
  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.25);
}
.chip-avatar {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chip-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chip-avatar-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chip-label { font-size: 13px; font-weight: 500; }
.pill-row { display: flex; flex-wrap: wrap; gap: 8px; }
.pill-row--finance {
  flex-direction: column;
  gap: 6px;
}
.filter-pill {
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.filter-pill--finance {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
}
.filter-pill--finance .filter-pill-text {
  font-size: 12px;
  font-weight: 600;
}
.filter-pill-icon-wrap {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.filter-pill-icon {
  font-size: 15px;
  line-height: 1;
}
.filter-pill--finance.filter-pill--aberto.active {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.25);
}
.filter-pill--finance.filter-pill--vencido.active {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.25);
}
.filter-pill--finance.filter-pill--pago.active {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.1);
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.25);
}
.filter-pill--finance.active .filter-pill-icon-wrap {
  transform: scale(1.05);
}
.filter-pill--finance.active .filter-pill-text {
  font-weight: 700;
}
.filter-pill.wide { flex: 1; text-align: center; }
.filter-pill.active:not(.filter-pill--finance) {
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border-color: transparent;
  color: #fff;
}
.datepicker-field { margin-bottom: 10px; }
.field-lbl {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 6px;
}
.tag-cat-block { margin-bottom: 14px; }
.tag-cat-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 8px;
  letter-spacing: 0.04em;
}
.tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tag-filter-item {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 2px solid transparent;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}
.tag-filter-item:hover { transform: translateY(-1px); }
.tag-filter-item.selected {
  border-color: #fff;
  box-shadow: 0 0 0 2px #6366f1, 0 4px 12px rgba(0, 0, 0, 0.2);
}
.tag-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}
.tag-name {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.tag-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 6px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.tag-item--sm {
  padding: 4px 8px;
  gap: 6px;
}
.tag-item--sm .tag-icon {
  width: 18px;
  height: 18px;
  font-size: 11px;
}
.tag-item--sm .tag-name {
  font-size: 10px;
}
.tag-item--readonly { cursor: default; padding-right: 12px; }
.tag-count {
  font-size: 12px;
  font-weight: 800;
  margin-left: 4px;
  opacity: 0.9;
}
.filtro-mov .sec-hint {
  margin-top: 0;
  margin-bottom: 10px;
}
.mov-panel {
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.mov-panel--active {
  border-color: rgba(245, 158, 11, 0.45);
  box-shadow: 0 0 0 1px rgba(245, 158, 11, 0.15);
}
.mov-panel-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-primary);
  transition: background 0.2s ease;
}
.mov-panel-toggle:hover {
  background: rgba(245, 158, 11, 0.04);
}
.mov-panel-icon {
  width: 34px;
  height: 34px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(245, 158, 11, 0.14);
  color: #d97706;
}
.mov-panel-icon svg {
  width: 18px;
  height: 18px;
}
.mov-panel--active .mov-panel-icon {
  background: rgba(245, 158, 11, 0.22);
  color: #b45309;
}
.mov-panel-copy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mov-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.3;
}
.mov-panel-desc {
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.35;
}
.mov-panel-switch {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  background: var(--border-primary);
  flex-shrink: 0;
  position: relative;
  transition: background 0.2s ease;
}
.mov-panel-switch::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
}
.mov-panel-toggle:has(input:checked) .mov-panel-switch {
  background: #f59e0b;
}
.mov-panel-toggle:has(input:checked) .mov-panel-switch::after {
  transform: translateX(18px);
}
.mov-stepper {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 8px 10px;
  padding: 12px;
  align-items: center;
}
.mov-stepper-label,
.mov-stepper-unit {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}
.mov-stepper-label {
  grid-column: 1;
  grid-row: 1;
}
.mov-stepper-unit {
  grid-column: 2;
  grid-row: 1;
  text-align: right;
}
.mov-stepper-control {
  grid-column: 1 / -1;
  grid-row: 2;
  display: flex;
  align-items: stretch;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  overflow: hidden;
}
.mov-stepper--disabled .mov-stepper-control {
  opacity: 0.45;
  pointer-events: none;
}
.mov-step-btn {
  width: 36px;
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.mov-step-btn:hover:not(:disabled) {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
}
.mov-step-btn:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.mov-step-input {
  flex: 1;
  min-width: 0;
  border: none;
  border-left: 1px solid var(--border-primary);
  border-right: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  padding: 8px 4px;
  -moz-appearance: textfield;
}
.mov-step-input::-webkit-outer-spin-button,
.mov-step-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.mov-step-input:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px rgba(245, 158, 11, 0.35);
}
.mov-panel--active .mov-stepper-control {
  border-color: rgba(245, 158, 11, 0.35);
}
.sidebar {
  background: linear-gradient(180deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  max-height: calc(100vh - 32px);
  overflow: hidden;
}

.filtro-sec {
  padding: 14px 16px;
}

.filtro-sec--collapsed {
  padding-bottom: 10px;
}

/* Datepicker relatório */
:deep(.custom-datepicker--relatorio .dp__input) {
  min-height: 2.75rem;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  color: var(--text-primary);
  font-size: 13px;
}
:deep(.custom-datepicker--relatorio .dp__input_focus) {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.25);
}

/* Painel principal */
.panel-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.panel-head h2 { margin: 0; font-size: 18px; font-weight: 700; }
.panel-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.15);
  color: #6366f1;
}
.empty-hint { color: var(--text-secondary); font-size: 14px; padding: 12px 0; }
.kpi {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: linear-gradient(145deg, var(--bg-secondary), var(--bg-primary));
}
.kpi-icon { font-size: 28px; line-height: 1; }
.panel-card--full {
  width: 100%;
}
.panel-head-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.panel-head-icon {
  font-size: 28px;
  line-height: 1;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(99, 102, 241, 0.1);
}
.panel-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 400;
}
.panel-badge--neutral {
  background: var(--bg-primary);
  color: var(--text-secondary);
}
.panel-card--finance {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, rgba(99, 102, 241, 0.04) 100%);
}
.fin-dashboard {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.fin-stat-card {
  padding: 18px 20px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: box-shadow 0.2s, transform 0.2s;
}
.fin-stat-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.fin-stat-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.fin-stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.fin-stat-qtd {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--bg-secondary);
}
.fin-stat-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}
.fin-stat-value {
  font-size: 22px;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.2;
}
.fin-stat-bar-wrap {
  height: 6px;
  background: var(--bg-secondary);
  border-radius: 999px;
  overflow: hidden;
  margin-top: 4px;
}
.fin-stat-bar {
  height: 100%;
  border-radius: 999px;
  min-width: 4px;
  transition: width 0.4s ease;
}
.fin-stat-pct {
  font-size: 11px;
  color: var(--text-secondary);
}
.fin-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--border-primary);
  font-size: 14px;
  color: var(--text-secondary);
}
.fin-total-row strong {
  font-size: 20px;
  font-weight: 800;
  color: var(--text-primary);
}
.panel-card--horas {
  background: linear-gradient(135deg, var(--bg-secondary) 0%, rgba(139, 92, 246, 0.04) 100%);
}
.horas-dashboard {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.hora-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  transition: box-shadow 0.2s;
}
.hora-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}
.hora-rank {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: rgba(99, 102, 241, 0.12);
  color: #6366f1;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hora-card:nth-child(1) .hora-rank {
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
  color: #fff;
}
.hora-card:nth-child(2) .hora-rank {
  background: linear-gradient(135deg, #94a3b8, #cbd5e1);
  color: #fff;
}
.hora-card:nth-child(3) .hora-rank {
  background: linear-gradient(135deg, #b45309, #d97706);
  color: #fff;
}
.hora-avatar {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hora-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hora-avatar-fallback {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hora-bar-col {
  flex: 1;
  min-width: 0;
}
.hora-bar-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 8px;
}
.hora-nome {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hora-tempo {
  font-size: 14px;
  font-weight: 800;
  color: #6366f1;
  flex-shrink: 0;
}
.hora-bar-wrap {
  height: 10px;
  background: var(--bg-secondary);
  border-radius: 999px;
  overflow: hidden;
}
.hora-bar {
  height: 100%;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  border-radius: 999px;
  min-width: 4px;
  transition: width 0.4s ease;
}
.tags-list--main { margin-top: 4px; }
.tasks-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
@media (max-width: 900px) {
  .fin-dashboard { grid-template-columns: 1fr; }
}

</style>
